function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "AWS-Kinesis_Firehose_Purple");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  cx: "51.2105525%",
  cy: "50%",
  fx: "51.2105525%",
  fy: "50%",
  r: "64.4102608%",
  id: "radialGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4BA7FA",
  offset: "100%"
})), /*#__PURE__*/React.createElement("radialGradient", {
  cx: "50%",
  cy: "50%",
  fx: "50%",
  fy: "50%",
  r: "60.8048397%",
  id: "radialGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46A8FA",
  offset: "100%"
})), /*#__PURE__*/React.createElement("path", {
  d: "M348,139.441319 C331.811931,59.8991558 260.837235,0 175.733002,0 C78.678345,0 0,77.9024535 0,174 C0,270.097546 78.678345,348 175.733002,348 L175.733002,348 C260.188027,348 330.728264,289.011226 347.619987,210.375569",
  id: "path-3"
}), /*#__PURE__*/React.createElement("circle", {
  id: "path-5",
  cx: 45.5,
  cy: 45.5,
  r: 45.5
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1-Copy",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "AWS-Kinesis_Firehose_Purple"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(26.000000, 26.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FCFEFE",
  xlinkHref: "#path-3"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "url(#radialGradient-2)",
  strokeWidth: 6,
  fillOpacity: 0.0199999996,
  fill: "url(#radialGradient-1)",
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("text", {
  id: 10100010101011112000,
  opacity: 0.071727808,
  mask: "url(#mask-4)",
  fontFamily: ".SFNSDisplay, .SF NS Display",
  fontSize: 28,
  fontWeight: "normal",
  "line-spacing": 32,
  letterSpacing: 3.20000005,
  fill: "#3D556B"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -6.96,
  y: 30.9771429
}, "101000101010111110000"), /*#__PURE__*/React.createElement("tspan", {
  x: -6.96,
  y: 62.9771429
}, "0011101000101010111110"), /*#__PURE__*/React.createElement("tspan", {
  x: -6.96,
  y: 94.9771429
}, "000001110100010101011"), /*#__PURE__*/React.createElement("tspan", {
  x: -6.96,
  y: 126.977143
}, "111000000111010001010"), /*#__PURE__*/React.createElement("tspan", {
  x: -6.96,
  y: 158.977143
}, "1011111000000111010001"), /*#__PURE__*/React.createElement("tspan", {
  x: -6.96,
  y: 190.977143
}, "0101011111000000111010"), /*#__PURE__*/React.createElement("tspan", {
  x: -6.96,
  y: 222.977143
}, "0010101011111000000111"), /*#__PURE__*/React.createElement("tspan", {
  x: -6.96,
  y: 254.977143
}, "010001010101111100000"), /*#__PURE__*/React.createElement("tspan", {
  x: -6.96,
  y: 286.977143
}, "0111010001010101111100"), /*#__PURE__*/React.createElement("tspan", {
  x: -6.96,
  y: 318.977143
}, "0000111010001010101111"), /*#__PURE__*/React.createElement("tspan", {
  x: -6.96,
  y: 350.977143
}, "100000011"))), /*#__PURE__*/React.createElement("path", {
  d: "M288.370366,163 C282.378313,106.233402 234.354789,62 176,62 C113.591823,62 63,112.591823 63,175 C63,237.408177 113.591823,288 176,288 C234.354789,288 282.378313,243.766598 288.370366,187 L338,187 L338,163 L288.370366,163 Z",
  id: "Combined-Shape",
  stroke: "#444444",
  strokeWidth: 6,
  fill: "#E3E5EB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M264.5,187 L289.5,187",
  id: "Path",
  stroke: "#444444",
  strokeWidth: 6
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-3-Copy",
  stroke: "#444444",
  strokeWidth: 6,
  transform: "translate(347.500000, 175.500000) scale(-1, 1) translate(-347.500000, -175.500000) ",
  x: 338,
  y: 152,
  width: 19,
  height: 47,
  rx: 1
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-3-Copy-2",
  stroke: "#444444",
  strokeWidth: 6,
  fill: "#D4C1FF",
  points: "357 159.045917 384 166.025287 384 184.02063 357 191"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-2",
  stroke: "#444444",
  strokeWidth: 6,
  fill: "#D4C1FF",
  cx: 174.5,
  cy: 175.5,
  r: 90.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-3",
  stroke: "#444444",
  strokeWidth: 6,
  fill: "#A260FF",
  cx: 174,
  cy: 176,
  r: 68
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(129.000000, 130.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("use", {
  id: "Oval-Copy-4",
  stroke: "#444444",
  strokeWidth: 6,
  fill: "#FFFFFF",
  xlinkHref: "#path-5"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-6)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.000000, 21.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "#444444",
  x: 0,
  y: 0,
  width: 48,
  height: 41,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy",
  fill: "#444444",
  x: 13,
  y: 41,
  width: 22,
  height: 29
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy",
  fill: "#D4C1FF",
  x: 5,
  y: 18,
  width: 38,
  height: 16
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  fill: "#A260FF",
  x: 18,
  y: 41,
  width: 12,
  height: 25.2925166
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-3",
  fill: "#F8F8F6",
  x: 4,
  y: 6,
  width: 40,
  height: 5
})))), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-4",
  fill: "#444444",
  x: 392,
  y: 165,
  width: 6,
  height: 20
}))));

const SvgFirehose = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "450px",
  height: "400px",
  viewBox: "0 0 450 400",
  style: {
    background: "#FFFFFF"
  },
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFirehose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/firehose.76ba2a9c.svg";
export { ForwardRef as ReactComponent };